import React, { useCallback, useState } from 'react';
import { Radio } from 'antd';
import { Text, CustomButton, CustomImage, CustomModal, useText } from '@src/components';
import { useDispatch } from 'react-redux';
import modalClose from '@src/assets/icons/icon-close.svg';
import '../payWithNewCard/payWithNewCard.scss';
import { Header } from '@src/components/CustomDialog';
import modalWarning from '@src/assets/icons/icon-modal-warning.svg';
import {
  setPayLaterDayForThanksPage,
  setPayWithLinkinEmail,
} from '@src/store/slice/mobilExpressSlice';
import dayjs from '@src/utils/day';

const radioContentStyle = { display: 'flex', flexDirection: 'column' };
const radioTitleStyle = { marginBottom: 2 };

const renderOption = (option, value) => (
  <Radio
    id={option.id}
    key={option.value}
    value={option.value}
    style={option.wrapperStyle}
    className={value !== 0 && value !== option.value ? 'ant-radio-wrapper-unchecked' : null}
  >
    <div className={option.wrapperClassName} style={radioContentStyle}>
      <span className="compliments-bold-text" style={radioTitleStyle}>
        {option.title}
      </span>
      <Text t={option.description} />
    </div>
  </Radio>
);

const PayWithNewCard = ({
  setModalVisible,
  saveAction,
  paymentLater,
  orderDate,
  setPaymentOrderDueDate = () => { },
  formVisible,
  form
}) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState(0);

  const attentionText = useText('attention');

  const paymentOptions = [
    {
      id: 'ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content1',
      value: 1,
      wrapperStyle: { marginBottom: 10 },
      wrapperClassName: 'credit-card-title',
      title: useText('saveMyCardAutomaticallyCollectOnPaymentDay'),
      description: useText(
        'yourCardInformationIsStoredSecurelyAndPayment',
      ),
    },
    {
      id: 'ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content2',
      value: 2,
      wrapperClassName: 'eftTransfer-card-title',
      title: useText('donTSaveMyCardSendMeA'),
      description: useText('yourCardInformationIsNotStored'),
    },
  ];

  const handler = async () => {
    await dispatch(
      setPayLaterDayForThanksPage(dayjs(orderDate).utc(true).utcOffset(180).toISOString()),
    );
    if (value === 1) {
      try {
        await form.setFieldsValue({
          cardSaveChecked: true,
        });
        await form.validateFields();
      } catch (e) {
        setModalVisible(false);
      }
      await dispatch(setPayWithLinkinEmail(false));
      await saveAction();
    } else {
      await dispatch(setPayWithLinkinEmail(true));
      setPaymentOrderDueDate(null);
      await paymentLater();
    }
  };

  const onChange = useCallback(
    async (e) => {
      setValue(e.target.value);
      if (e.target.value === 1) await form.validateFields();
    },
    [form],
  );

  return (
    <CustomModal
      className="pay-with-new-card"
      width={583}
      maskClosable={false}
      footer={false}
      title={<Header title={attentionText} type={'warning'} icon={modalWarning}></Header>}
      visible={true}
      onCancel={async () => {
        await dispatch(setPayLaterDayForThanksPage(null));
        setModalVisible(false);
      }}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className={'modal-inner-container'}>
        <Radio.Group
          id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radioGroup-input-content"
          onChange={onChange}
          value={value}
          className="custom-radio-input-content"
        >
          {paymentOptions.map((option) => renderOption(option, value))}
        </Radio.Group>
        <CustomButton
          id="ticketRestaurant-paymentModals-payWithNewCardCompliments-payWithNewCardCompliments-pay-now"
          disabled={value === 0}
          className="pay-now"
          onClick={handler}
        >
          <Text t="continue2" />
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default PayWithNewCard;
